import { Icon } from "@chakra-ui/react";

export const WarningIcon = (props) => (
   <Icon viewBox="0 0 12 12" {...props}>
      <path
         d="M6,0 C2.6862875,0 0,2.6862875 0,6 C0,9.3137125 2.6862875,12 6,12 C9.3137125,12 12,9.3137125 12,6 C12,2.6862875 9.3137125,0 6,0 Z"
         fill="#FF9500"
      />
      <path
         d="M5.45,3.5566875 C5.45,4.3066875 6.575,4.3066875 6.575,3.5566875 L6.575,3.2 C6.575,2.45 5.45,2.45 5.45,3.2 L5.45,3.5566875 L5.45,3.5566875 Z"
         fill="#FFFFFF"
      />
      <path
         d="M5.45,8.8 C5.45,9.55 6.575,9.55 6.575,8.8 L6.575,5.375 C6.575,4.625 5.45,4.625 5.45,5.375 L5.45,8.8 Z"
         fill="#FFFFFF"
      />
   </Icon>
);
